import { createContext } from 'react';
import type { MenuContextProps } from '../../../Models/Template';

export const MenuContext = createContext({} as MenuContextProps);
